<template>
<div>
    <header-landing-component></header-landing-component>
    <section>
        <div class="container">
            <div class="row">
                <div class="col-md-12">
                    <div class="heading-text heading-section">
                        <h2 style="font-size: 2.85rem">GRACIAS POR TU INTERÉS EN NUESTROS PRODUCTOS, EN BREVE NOS PONDREMOS EN CONTACTO CONTIGO</h2>
                    </div>
                </div>
            </div>
        </div>
    </section>
    <footer-landing-component></footer-landing-component>
</div>
</template>

<script>
    import HeaderLandingComponent from "../../components/Landing/HeaderLandingComponent.vue"
    import FooterLandingComponent from "../../components/Landing/FooterLandingComponent.vue"
    import LeadComponent from "../../components/Landing/LeadComponent.vue"
	export default {
		name: 'autodesk',
        components: {
			HeaderLandingComponent,
            FooterLandingComponent,
            LeadComponent
		},   
		data() {
			return {
            }
        },
		methods: {
        },
		mounted() {
        }        
    }

</script>